export const sliceName = 'questions'
